export default __webpack_public_path__ + "static/media/eye-no.452c80ae.svg";